
import { useNavigate, useLocation } from 'react-router-dom';
import { Modal, Button } from 'react-bootstrap';
import RegionForm from '../components/forms/RegionForm';
import '../styles/EmployeeMaster.css';
import RegionTable from '../components/RegionTable';

const RegionModel = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const showModal = location.pathname === '/region/add';

  const handleAddClick = () => {
    navigate('/region/add');
  };

  const handleCloseModal = () => {
    navigate('/region');
  };

  return (
    <div className="employee-master-page">
      <div className="employee-header">
        <h2>Region Master</h2>
        <button className="add-employee-btn" onClick={handleAddClick}>
          Add Region
        </button>
      </div>

      <RegionTable />

      <Modal
        show={showModal}
        onHide={handleCloseModal}
        size="md"
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>Add New Region</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <RegionForm />
        </Modal.Body>
        {/* <Modal.Footer>
          <Button variant="secondary" onClick={handleCloseModal}>
            Close
          </Button>
          <Button variant="primary">
            Save
          </Button>
        </Modal.Footer> */}
      </Modal>
    </div>
  );
};

export default RegionModel;
